import { useState } from "react";
import { maxLengthValidation } from "src/utils/validation";
import BillUI from "./ConsoleBill.presenterNew";
import moment from "moment";
import { getProductFromSessionStorage } from "src/utils/storage/auth";
import { useRecoilState } from "recoil";
import {
  isInitAtom,
  isShowPayAtom,
  navStepAtom,
  payPlanInfoAtom,
  typeAtom,
  userInfoAtom,
} from "src/atoms";
import {
  checkPromotionCode,
  createServiceBill,
  getInicisData,
  subscriptionSuspend as inicisSubscriptionsSuspend,
  subscriptionActive as inicisSubscriptionsActivate,
  confirmUser as inicisConfirm,
  updateCashStatus,
} from "src/service/pay";
import { sleep } from "src/utils/common";
import { useRouter } from "src/hooks/useRouter";
import {
  subscriptionsActivate as paypalSubscriptionsActivate,
  subscriptionsSuspend as paypalSubscriptionsSuspend,
  subscriptionsRevise,
} from "src/service/paypal";
import { useApiError } from "src/hooks/useApiError";
import { useCheckHasBill } from "src/hooks/validation/useCheckHasBill";
import { useCheckIsRenew } from "src/hooks/validation/useCheckIsRenew";
import {
  ICreateServiceBillReq,
  IUpdateCashStatus,
} from "src/service/types/pay.type";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import PriceChecker from "components/Site/Pay/PriceChecker";
import { Formik } from "formik";
import { useGetCashStatus } from "src/hooks/api/pay/useGetCashStatus";
import { useGetBillHistory } from "src/hooks/api/pay/useGetBillHistory";
import { useServiceNo } from "src/hooks/recoil/useIsServiceNo";
import { useTranslation } from "react-i18next";

interface IConsoleContainerProps {}
const ConsoleBillContainer = () => {
  const { serviceNo } = useServiceNo();
  const { t } = useTranslation();
  const [modal, setModal] = useState({
    confirmPriceIsActive: false,
    confirmUserIsActive: false,
    confirmPayTermIsActive: false,
    modalSubscriptionsCancel: false,
    modalSubscriptionsActivate: false,
    modalCheckConfirmPrice: false,
    modalCheckConfirmUser: false,
  });
  const [userPerPrice, setUserPerPrice] = useState(0);
  const [licenseCount, setLicenseCount] = useState(0);
  const [changeLicenseCount, setChangeLicenseCount] = useState(0);
  const [priceType, setPriceType] = useState("");
  const [payTerm, setPayTerm] = useState("");
  const [subscriptionId, setSubscriptionId] = useState<string>("");
  const [changePriceType, setChangePriceType] = useState("");
  const [changePayTerm, setChangePayTerm] = useState("");
  const [serviceBillUid, setServiceBillUid] = useState<string>("");

  const [userPerPriceYear, setUserPerPriceYear] = useState<number>(0);
  const [planId, setPlanId] = useState<string>(""); // planId --> paypal 버튼에 사용됨
  const [priceUid, setPriceUid] = useState<string>("");

  const [changeUserPerPrice, setChangeUserPerPrice] = useState(0);
  const [changePrice, setChangePrice] = useState(0);
  const [changePriceIncTax, setChangePriceIncTax] = useState(0);

  const [changeNextPayDate, setChangeNextPayDate] = useState<string>();
  const [isChangePrice, setIsChangePrice] = useState(false);
  const [confirmUrl, setConfirmUrl] = useState("");
  const [showSalesSlip, setShowSalesSlip] = useState(false);
  const [showBillStatement, setShowBillStatement] = useState(false);
  const [serviceBillHisUid, setServiceBillHisUid] = useState("");
  const [nowDate, setNowDate] = useState(moment().format("YYYYMMDD"));
  const [nowTime, setNowTime] = useState(moment(Date.now()));
  const [dateDifference, setDateDifference] = useState(0);
  const [noContent, setNoContent] = useState(false);
  const [totalPageNumber, setTotalPageNumber] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [currency, setCurrency] = useState("");
  const [payCompany, setPayCompany] = useState("");
  const [inicisData, setInicisData] = useState<any>();
  const [newDepositName, setNewDepositName] = useState("");
  // const [cashStatus, setCashStatus] = useState("");
  const [serviceUid, setServiceUid] = useState("");
  const [showCashRequestDel, setShowCashRequestDel] = useState(false);
  const [deleteCashReqMsg, setDeleteCashReqMsg] = useState("");
  const [selectAppList, setSelectAppList] = useState<string[]>([]);
  const [nxacAppUids, setNxacAppUids] = useState<string[]>([]);
  // const [userCashStatus, setUserCashStatus] = useState({
  //   approvedUserCode: "",
  //   billCode: "",
  //   billType: "",
  //   depositor: "",
  //   entryTime: 0,
  //   externalLicenseCount: 0,
  //   licenseCount: 0,
  //   msg: "",
  //   ownerUserCode: "",
  //   payDate: "",
  //   payTerm: "",
  //   referralId: "",
  //   regUserCode: "",
  //   serviceCashUid: "",
  //   serviceUid: "",
  //   status: "",
  //   totalPrice: 0,
  //   upc: "",
  //   updUserCode: "",
  //   updateTime: 0,
  //   userPerStorage: 0,
  //   nxacAppUids: "",
  //   taxInvoiceDTO: {
  //     owner: "",
  //     businessNumber: "",
  //     requestDate: moment(Date.now()),
  //     issuer: "",
  //     phoneNumber: "",
  //     email: "",
  //   },
  // });
  const { userCashStatusLoading, userCashStatus, userCashStatusRefetch } =
    useGetCashStatus({ onSuccess: () => {} });
  const [isCheckPay, setIsCheckPay] = useState<boolean>(false);
  const [showTaxInvoiceFields, setShowTaxInvoiceFields] = useState(false);
  const [product, setProduct] = useState(getProductFromSessionStorage());

  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [isShowPay, setIsShowPay] = useRecoilState(isShowPayAtom);
  const [isInit, setIsInit] = useRecoilState(isInitAtom);
  const [type, setType] = useRecoilState(typeAtom);
  const [payPlanInfo, setPayPlanInfo] = useRecoilState(payPlanInfoAtom);

  const [listType, setListType] = useState<string>("");
  //확인할 state
  const [promotionCode, setPromotionCode] = useState("");
  const [isCheckPromotionCode, setIsCheckPromotionCode] = useState<string>();
  const route = useRouter();

  // const [myServiceList, setMyServiceList] = useState<any>();
  const { serviceList: myServiceList } = useGetMyServiceList({});
  const { isRenew } = useCheckIsRenew({
    serviceList: myServiceList,
    serviceNo,
  });
  const { handleError } = useApiError();

  // 사이트 결제 유무 체크
  useCheckHasBill();

  const { isBillHistoryLoading, billHistory } = useGetBillHistory({});
  // 결제 카드 교체 정보 (일단 ReactInicis 내부에서 요청으로 대체)
  const payApply = async ({
    orderID,
    subscriptionID,
  }: {
    orderID: string;
    subscriptionID: string;
  }) => {
    // if (isCheckPay) {
    try {
      if (myServiceList !== undefined && myServiceList.length > 0) {
        const serviceRequest: ICreateServiceBillReq = {
          billType: myServiceList[serviceNo]?.billType,
          currency: myServiceList[serviceNo]?.currency,
          licenseCount: myServiceList[serviceNo]?.licenseCount,
          orderID,
          payCompany: subscriptionID === "Inicis" ? "INICIS" : "PAYPAL",
          payTerm: myServiceList[serviceNo]?.payTerm,
          serviceBillUid: isRenew
            ? myServiceList[serviceNo]?.serviceBillUid
            : "",
          subscriptionID,
          userCode: userInfo?.userCode,
        };

        serviceRequest.serviceBillUid =
          myServiceList[serviceNo]?.serviceBillUid;

        // const result = await createServiceBill({ ...serviceRequest });

        // if (result) {
        //   alert(t("common.alert.changeCard"));
        //   if (myServiceList === undefined || myServiceList.length === 0) {
        //     // this.commonStore.setNavStep(3)
        //     setNavStep(3);

        //     setShowSiteNewModal(true);
        //     setIsShowPay(false);
        //     setIsInit(false);
        //     setType("pay");
        //     setServiceBillUid(result.serviceBillUid);
        //   } else {
        //     // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`;
        //     route.goConsole();
        //   }
        //   if (payCompany === "PAYPAL") {
        //     route.goConsole();
        //   }
        // }
      }
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    // this.commonStore.setLoading(false);
    // }
  };

  // useEffect(() => {
  // async function init() {
  //   if (myServiceList) {
  //     let listType = "";

  //     if (myServiceList === undefined) {
  //       // serviceList = await PayActions.getMyServiceBill(
  //       //   sessionStorage.getItem('product')
  //       // )
  //       listType = "pay";
  //     } else {
  //       listType = "service";
  //     }

  //     try {
  //       let noContent;
  //       const currency = localStrings.getLanguage() === "ko" ? "WON" : "USD";

  //       // let isPaypal = true;
  //       //let currency
  //       // let refreshSchedule = true;
  //       const payCompany =
  //         myServiceList[0].payCompany === "CASH"
  //           ? "INICIS"
  //           : myServiceList[0].payCompany;
  //       let inicisData;
  //       const priceInfo = {
  //         status: "REAL",
  //         product: [getProductFromSessionStorage()],
  //       };
  //       //pay/price/list
  //       const priceList = await getPriceList({ ...priceInfo });

  //       if (myServiceList.length > 0) {
  //         setServiceBillUid(myServiceList[0]?.serviceBillUid);
  //         setLicenseCount(myServiceList[0]?.licenseCount);
  //         setPriceType(myServiceList[0]?.priceType);
  //         setPayTerm(myServiceList[0]?.payTerm);
  //         setSubscriptionId(myServiceList[0]?.subscriptionId);
  //         setNextPayDate(myServiceList[0]?.nextPayDate);
  //         setChangeNextPayDate(
  //           moment(myServiceList[0].nextPayDate).format("YYYYMMDD")
  //         );
  //         console.log(
  //           'moment(myServiceList[0].nextPayDate).format("YYYYMMDD")',
  //           moment(myServiceList[0].nextPayDate).format("YYYYMMDD")
  //         );
  //         console.log("myServiceList", myServiceList);
  //         setChangePayTerm(myServiceList[0].payTerm);
  //       }

  //       if (myServiceList?.length === 0 && billHistory?.length === 0) {
  //         noContent = true;
  //       }

  //       if (subscriptionId && payCompany === "PAYPAL") {
  //         const isConfirm = await getSubscription({ subscriptionId });
  //         if (isConfirm) {
  //           setIsChangePrice(false);
  //           //  confirmUrl = isConfirm.confirmUrl
  //           //  this.checkPrice(subscriptionId)
  //         } else {
  //           setIsChangePrice(true);
  //         }
  //       } else if (payCompany === "INICIS") {
  //         setIsChangePrice(true);
  //         await getInicisData({ price: 0 }).then((res) => {
  //           setInicisData(res);
  //         });
  //       }
  //       const uid = myServiceList[0].serviceUid;
  //       let statusResult;
  //       //현금결제 serviceId 받기
  //       const checkCashStatus = await getCashUserStatus({
  //         product: [getProductFromSessionStorage()],
  //       });
  //       if (checkCashStatus) {
  //         statusResult = {
  //           ...checkCashStatus,
  //           taxInvoiceDTO: checkCashStatus.taxInvoiceDTO
  //             ? checkCashStatus.taxInvoiceDTO
  //             : {
  //                 owner: "",
  //                 businessNumber: "",
  //                 requestDate: moment(Date.now()),
  //                 issuer: "",
  //                 phoneNumber: "",
  //                 email: "",
  //               },
  //         };
  //       }

  //       //현재 날짜와 nextPay 날짜간의 일수 차이 계산
  //       let diffDate2 = 0;
  //       if (myServiceList[0].billType === "PAY") {
  //         const newNowDate =
  //           nowDate.substring(0, 4) +
  //           "-" +
  //           nowDate.substring(4, 6) +
  //           "-" +
  //           nowDate.substring(6);
  //         const newNextDate =
  //           nextPayDate.substring(0, 4) +
  //           "-" +
  //           nextPayDate.substring(4, 6) +
  //           "-" +
  //           nextPayDate.substring(6);

  //         const date1 = new Date(newNowDate);
  //         const date2 = new Date(newNextDate);

  //         const diffDate = date1.getTime() - date2.getTime();
  //         diffDate2 = Math.abs(diffDate / (1000 * 60 * 60 * 24));
  //       }
  //       fetch;
  //     } catch (error) {
  //       // console.log("sdfsdf", error);
  //     }
  //   }
  // }
  // if (myServiceList) {
  // getCreditHistory({ serviceUid: "2eed79d5f6b34cba8670d31f4ba8fbe2" });
  // getTotalCredit({ serviceUid: "2eed79d5f6b34cba8670d31f4ba8fbe2" });
  // init();
  // }
  // }, [myServiceList]);

  const toggleTaxInvoidFields = () => {
    setShowTaxInvoiceFields((prev) => !prev);
  };

  // const getBillHistory = async (newPage: number) => {
  //   try {
  //     const offset = (newPage - 1) * limit;
  //     const result = await getBillHistoryReq({
  //       offset,
  //       limit,
  //       order,
  //       product,
  //     });
  //     setPageNumber(newPage);
  //     // setBillHistory(result.billHistory);
  //     setTotalCount(result.count);
  //     setTotalPageNumber(Math.ceil(result.count / limit));
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // paypal 관련
  const checkPrice = async (subscriptionId: string) => {
    // let isConfirm = await getSubscription(subscriptionId);
    // while (isConfirm) {
    //   isConfirm = await PayActions.getSubscription(subscriptionId);
    //   await sleep(5000);
    // }
    // let isChangePrice = true;
    // let confirmUrl = "";
    // const serviceList = await ServiceActions.getMyServiceList(
    //   sessionStorage.getItem("product")
    // );
    // this.setState({
    //   serviceList,
    //   isChangePrice,
    //   confirmUrl,
    // });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // const licenseCount = state["licenseCount"];
    //let list = state['selectAppList'];
    // 확인필요
    if (e.target.name === "selectAppList") {
      if (selectAppList.indexOf(e.target.value) !== -1) {
        setSelectAppList(selectAppList.filter((el) => el !== e.target.value));
        setNxacAppUids(selectAppList.filter((el) => el !== e.target.value));
      } else {
        setSelectAppList((prev) => prev.concat(e.target.value));
        setNxacAppUids((prev) => prev.concat(e.target.value));
      }

      // setNxacAppUids(selectAppList);

      // //console.log('nxacAppUids', state['nxacAppUids'])
      // this.setState(state);
      return;
    }

    if (e.target.name === "changeLicenseCount") {
      const regexp = new RegExp(`^-?[0-9]*$`);
      if (!regexp.test(e.target.value)) {
        return;
      }

      if (
        Number(e.target.value) < 0 ||
        Number(e.target.value) > 9999 - licenseCount
      ) {
        // 추가 사용자 수는 최소 0명에서 최대 {0}명까지 지정 가능합니다. (추후 다시 만들것!!!)
        // alert(
        //   t(
        //     "siteManagement.paymentHistory.popUp.changeNumberOfUsers.changeNumberUserMsg",
        //     9999 - licenseCount
        //   )
        // );
        return;
      }
    }

    if (e.target.name === "changePayTerm") {
      setChangePayTerm(e.target.value);
    }
    // state 확인
    if (e.target.name === "checkPay") {
      setIsCheckPay((prev) => !prev);
    }
  };

  // 요금제변경에서 요금제 선택시 가격 세팅
  // const checkUserPerPrice = ({
  //   userPerPrice,
  //   changeUserPerPrice,
  // }: {
  //   userPerPrice: number;
  //   changeUserPerPrice: number;
  // }) => {
  //   // 1	액터가 상위 요금제를 선택한다.(베이직 → 플러스)
  //   // 1.1	액터가 상위 요금제를 선택한 경우 시스템은 추가 요금을 계산한다.
  //   // 1.2	월 구독 사용자인 경우
  //   // 1.2.1	일일 요금 = (플러스요금-베이직요금) * 12 / 365
  //   // 1.2.2	청구 요금 = 내일부터 다음 결제일까지 남은 일수 * 일일 요금 * 사용자
  //   // 1.3	년 구독 사용자인 경우
  //   // 1.3.1	일일 요금 = (플러스요금-베이직요금) * 10 / 365
  //   // 1.3.2	청구 요금 = 내일부터 다음 결제일까지 남은 일수 * 일일 요금 * 사용자

  //   // 2	액터가 사용자를 추가 결제한다.
  //   // 2.1	월 구독 사용자인 경우
  //   // 2.1.1	일일 요금 = (플러스요금-베이직요금) * 12 / 365
  //   // 2.1.2	청구 요금 = 내일부터 다음 결제일까지 남은 일수 * 일일 요금 * 추가 사용자
  //   // 2.2	년 구독 사용자인 경우
  //   // 2.2.1	일일 요금 = (플러스요금-베이직요금) * 10 / 365
  //   // 2.2.2	청구 요금 = 내일부터 다음 결제일까지 남은 일수 * 일일 요금 * 추가 사용자

  //   // 3	액터가 결제 주기 변경을 선택한 경우
  //   // 3.1	시스템은 현재 구독 플랜이 표시된 팝업을 표시하고 다른 플랜으로 변경할 수 있게 한다.
  //   // 현재 구독중인 요금제가 끝나는 시점에 선택한 구독 주기로 변경된다.
  //   // 다음 청구일부터 통합 청구 시작

  //   const currentTime = moment(moment().valueOf());
  //   const nextPayDate2 = moment(nextPayDate, "YYYYMMDD");
  //   const remainDay = nextPayDate2.diff(currentTime, "day") + 1;

  //   let cal = 0;

  //   console.log("handle userPerPrice", userPerPrice, changeUserPerPrice);
  //   // 요금제 상향일 경우
  //   if (userPerPrice < changeUserPerPrice) {
  //     cal =
  //       (((Number(changeUserPerPrice) - Number(userPerPrice)) * 12) / 365) *
  //       Number(licenseCount) *
  //       remainDay;
  //   }
  //   // 사용 인원 변경일 경우
  //   if (Number(changeLicenseCount) > 0) {
  //     let calPrice = 0;
  //     if (priceType === "plus" && payTerm === "year") {
  //       calPrice = plusUserPerPriceYear;
  //     } else if (priceType === "plus" && payTerm === "month") {
  //       calPrice = plusUserPerPrice;
  //     } else if (priceType === "basic" && payTerm === "year") {
  //       calPrice = basicUserPerPriceYear;
  //     } else if (priceType === "basic" && payTerm === "month") {
  //       calPrice = basicUserPerPrice;
  //     } else if (priceType === "plusPlus" && payTerm === "year") {
  //       calPrice = plusPlusUserPerPriceYear;
  //     } else if (priceType === "plusPlus" && payTerm === "month") {
  //       calPrice = plusPlusUserPerPrice;
  //     } else if (priceType === "basicPlus" && payTerm === "year") {
  //       calPrice = basicPlusUserPerPriceYear;
  //     } else if (priceType === "basicPlus" && payTerm === "month") {
  //       calPrice = basicPlusUserPerPrice;
  //     }

  //     cal =
  //       ((Number(Number(calPrice)) * 12) / 365) *
  //       Number(changeLicenseCount) *
  //       remainDay;
  //   }
  //   if (cal >= 0) {
  //     if (payCompany === "PAYPAL") {
  //       setChangePrice(Math.floor(cal * 100) / 100);
  //       setChangePriceIncTax(Math.floor(cal * 1.1 * 100) / 100);
  //     } else {
  //       setChangePrice(Math.floor(cal));
  //       setChangePriceIncTax(Math.floor(cal * 1.1));
  //     }
  //   }
  // };

  const toggleModalConfirmPrice = async () => {
    if (myServiceList) {
      setModal((prev) => ({
        ...prev,
        confirmPriceIsActive: !prev.confirmPriceIsActive,
      }));
      setPriceType(myServiceList[serviceNo].priceType);
      setChangePriceType(myServiceList[serviceNo].priceType);
      setLicenseCount(myServiceList[serviceNo].licenseCount);
      // setChangeLicenseCount( 0)
      setChangeUserPerPrice(userPerPrice);
      setPayTerm(myServiceList[serviceNo].payTerm);
      setUserPerPrice(userPerPrice);
      setChangePayTerm(myServiceList[serviceNo].payTerm);

      setChangePrice(0);
      setChangePriceIncTax(0);
      // setPromotionCode( '')
      // setIsCheckPromotionCode( '')
    }
  };

  // 유저수 확인 모달
  const toggleModalConfirmUser = () => {
    if (myServiceList) {
      setModal((prev) => ({
        ...prev,
        confirmUserIsActive: !prev.confirmUserIsActive,
      }));
      setPriceType(myServiceList[serviceNo].priceType);
      setChangePriceType(myServiceList[serviceNo].priceType);
      setLicenseCount(myServiceList[serviceNo].licenseCount);
      // setChangeLicenseCount( 0)
      setChangeUserPerPrice(userPerPrice);
      setPayTerm(myServiceList[serviceNo].payTerm);
      setUserPerPrice(userPerPrice);
      setChangePayTerm(myServiceList[serviceNo].payTerm);

      setChangePrice(0);
    }
  };

  // 결제주기 모달
  const toggleModalConfirmPayTerm = async () => {
    if (myServiceList) {
      setModal((prev) => ({
        ...prev,
        confirmPayTermIsActive: !prev.confirmPayTermIsActive,
      })),
        setPriceType(myServiceList[serviceNo].priceType);
      setChangePriceType(myServiceList[serviceNo].priceType);
      setLicenseCount(myServiceList[serviceNo].licenseCount);
      // setChangeLicenseCount( 0)
      setChangeUserPerPrice(userPerPrice);
      setPayTerm(myServiceList[serviceNo].payTerm);
      setUserPerPrice(userPerPrice);
      setChangePayTerm(myServiceList[serviceNo].payTerm);

      setChangePrice(0);
      setChangePriceIncTax(0);
    }
  };

  const toggleModalSubscriptionsActivate = () => {
    setModal((prev) => ({
      ...prev,
      modalSubscriptionsActivate: !prev.modalSubscriptionsActivate,
    }));
  };

  const toggleModalCheckConfirmPrice = () => {
    if (nxacAppUids.length > 3) {
      alert(t("cashStatus.chooseAppUntilThree"));
    } else {
      setModal((prev) => ({
        ...prev,
        modalCheckConfirmPrice: !prev.modalCheckConfirmPrice,
      }));
    }
  };

  const toggleModalCheckConfirmUser = () => {
    setModal((prev) => ({
      ...prev,
      modalCheckConfirmUser: !prev.modalCheckConfirmUser,
    }));
  };

  const changeServiceType = () => {
    route.goSiteType();
  };

  const renewSubscriptions = () => {
    if (myServiceList) {
      if (myServiceList[serviceNo].billType === "PAY") {
        if (["plus", "basic"].includes(myServiceList[serviceNo]?.priceType)) {
          route.goPay({
            pay: "renew",
            type: myServiceList[serviceNo]?.serviceBillUid,
          });
        }
      } else if (myServiceList[serviceNo].billType === "PROMOTION") {
        route.goSitePromotion({
          renewCode: myServiceList[serviceNo]?.serviceBillUid,
        });
      }
    }
  };

  const checkConfirmPayTerm = () => {
    // this.commonStore.setLoading(true)

    if (changePayTerm === payTerm) {
      toggleModalConfirmPayTerm();
      // this.commonStore.setLoading(false)
    } else {
      if (payCompany === "PAYPAL") {
        confirmPrice({ orderId: "", type: "payTerm" });
      } else {
        confirmPayterm();
      }
    }
  };

  // paypal 관련
  const confirmPrice = async ({
    orderId,
    type,
    authorizationID,
  }: {
    orderId: string;
    type: string;
    authorizationID?: string;
  }) => {
    // this.commonStore.setLoading(true)
    const planId = getPlanId({
      priceType: changePriceType,
      payTerm: changePayTerm,
    });
    if (planId !== "") {
      const subscriptionsReviseReq = {
        plan_id: "",
        quantity: 0,
        orderId: "",
        authorizationID: "",
      };
      subscriptionsReviseReq.quantity =
        Number(licenseCount) + Number(changeLicenseCount);
      subscriptionsReviseReq.plan_id = planId ?? "";
      subscriptionsReviseReq.orderId = orderId;
      const result = await subscriptionsRevise({
        subscriptionId,
        subscriptionsReviseReq,
      });
      if (result) {
        const popup = window.open(
          result.approveHref,
          "_blank",
          "width=800, height=800"
        );

        while (popup && !popup.closed) {
          await sleep(1000);
        }
      }
    } else {
      alert(t("common.alert.failPayment"));
    }

    if (type === "user") {
      toggleModalConfirmUser();
    } else if (type === "price") {
      toggleModalConfirmPrice();
    } else if (type === "payTerm") {
      toggleModalConfirmPayTerm();
    }
    // this.commonStore.setLoading(false)

    window.location.reload();
  };

  // 구독 종료
  const subscriptionsSuspend = async (e: any) => {
    // this.commonStore.setLoading(true)
    e.preventDefault();

    const subscriptionsSuspendReq = {
      reason: "Suspend subscription",
    };

    if (myServiceList) {
      if (myServiceList[serviceNo]?.payCompany === "PAYPAL") {
        const result = await paypalSubscriptionsSuspend({
          subscriptionId,
          subscriptionsSuspendReq,
        }).then(() => {
          window.location.reload();
        });
      } else {
        const result = await inicisSubscriptionsSuspend({
          product: getProductFromSessionStorage(),
          another: "SUSPENDED",
        }).then(() => {
          window.location.reload();
        });
      }
    }
  };

  const subscriptionsActivate = async () => {
    // this.commonStore.setLoading(true)
    // console.log("subscriptionsActivate payCompany", payCompany);
    const subscriptionsActivateReq = {
      reason: "Activate subscription",
    };

    if (myServiceList) {
      if (myServiceList[serviceNo]?.payCompany === "PAYPAL") {
        const result = await paypalSubscriptionsActivate({
          subscriptionId,
          subscriptionsActivateReq,
        }).then(() => window.location.reload());
      } else {
        const result = await inicisSubscriptionsActivate({
          orderId: "PAYED",
          product: getProductFromSessionStorage(),
        }).then(() => window.location.reload());
      }
    }
    // this.commonStore.setLoading(false)
  };

  const checkConfirmUser = async () => {
    // this.commonStore.setLoading(true)

    // orderId 어디서 세팅했는지 확인하기
    if (myServiceList) {
      const confirmRequest = {
        serviceBillUid: myServiceList[serviceNo]?.serviceBillUid,
        type: "user",
        orderId: inicisData?.orderId,
        changePrice,
        licenseCount: Number(licenseCount) + Number(changeLicenseCount),
        product,
      };
      const result = await inicisConfirm({ ...confirmRequest });

      // this.commonStore.setLoading(false)

      window.location.reload();
    }
  };

  const checkConfirmPrice = async () => {
    // this.commonStore.setLoading(true)
    if (myServiceList) {
      const confirmRequest = {
        serviceBillUid: myServiceList[serviceNo]?.serviceBillUid,
        type: "priceType",
        orderId: inicisData?.orderId,
        changePrice,
        changePriceType,
        nxacAppUids,
        product,
      };
      const result = await inicisConfirm({ ...confirmRequest });

      // this.commonStore.setLoading(false)

      window.location.reload();
    }
  };

  const confirmPayterm = async () => {
    if (myServiceList) {
      const confirmRequest = {
        serviceBillUid: myServiceList[serviceNo]?.serviceBillUid,
        type: "payTerm",
        orderId: myServiceList[serviceNo].orderId,
        changePayTerm: changePayTerm,
        product: product,
      };
      const result = await inicisConfirm({ ...confirmRequest });
      toggleModalConfirmPayTerm();
      // this.commonStore.setLoading(false)

      window.location.reload();
    }
  };

  const getPlanId = ({
    priceType,
    payTerm,
  }: {
    priceType: string;
    payTerm: string;
  }) => {
    if (priceType) return "";
  };

  const hideModal = () => {
    setShowBillStatement(false);
    setServiceBillHisUid("");
  };

  const promotionApply = async () => {
    // promotionCode 상태 확인해보기
    // const { promotionCode } = this.state
    // let isCheckPromotionCode = "OK";

    if (promotionCode === "") {
      setIsCheckPromotionCode("FAIL");
    }

    if (!maxLengthValidation(promotionCode, 44)) {
      setIsCheckPromotionCode("FAIL");
    }

    try {
      const checkCode = await checkPromotionCode({
        promotionCode,
        product: getProductFromSessionStorage(),
      });

      if (checkCode) {
        // console.log(checkCode);
        if (checkCode.promotionCode === promotionCode) {
          setIsCheckPromotionCode("OK");
        } else {
          // 어디에 선언?
          setIsCheckPromotionCode("FAIL");
        }
      } else {
        setIsCheckPromotionCode("OK");
      }
    } catch (error) {
      setIsCheckPromotionCode("FAIL");
    }

    // const { serviceList, serviceNo, nxacAppUids } = this.state
    // const { userInfo } = this.props.store.commonStore.userInfo
    const serviceRequest = {
      serviceBillUid: "",
      serviceId: "",
      userCode: "",
      billType: "",
      billCode: "",
      region: "",
      product: "",
      serviceName: "",
      nxacAppUids: nxacAppUids,
    };

    serviceRequest.serviceBillUid = serviceBillUid;
    serviceRequest.userCode = userInfo.userCode;
    serviceRequest.billType = "PROMOTION";
    serviceRequest.billCode = promotionCode;

    const result = await createServiceBill(serviceRequest);
    // const lang = getLanguage()
    if (result) {
      // window.location.href = `${process.env.PUBLIC_URL}/${lang}/bill`
      route.goBill();
    } else {
      // 에러
    }
  };
  // 결제 카드 교체용 요청
  const requestPay = async () => {
    // e.preventDefault();

    await getInicisData({ price: 0 }).then((res) => {
      // console.log("click requestPay", res);
      setInicisData(res);
    });

    await payApply({ orderID: inicisData.oid, subscriptionID: "Inicis" });
  };

  const requestCashStatus = async () => {
    // let param = {
    //   serviceCashUid: this.state.userCashStatus.serviceCashUid,
    //   status: state,
    //   msg: this.state.deleteCashReqMsg
    // }

    if (myServiceList) {
      const param = {
        licenseCount: userCashStatus?.licenseCount,
        billType: userCashStatus?.billType, //"plus",
        billCode: userCashStatus?.billCode, //"d570d3e86b2842968f56ea93f3d2e9bf",
        payTerm: userCashStatus?.payTerm, //"year",
        totalPrice: userCashStatus?.totalPrice,
        referralId: userCashStatus?.referralId,
        nxacAppUids: userCashStatus?.nxacAppUids ?? [],
        depositor: newDepositName,
        //serviceUid: serviceUid,
        serviceUid: myServiceList[serviceNo].serviceBillUid,
        //serviceUid: userCashStatus.serviceCashUid,
        payDate: userCashStatus?.payDate,
        upc: userCashStatus?.upc,
        taxInvoice: {
          ...userCashStatus?.taxInvoiceDTO,
          requestDate: moment(userCashStatus?.taxInvoiceDTO.requestDate).format(
            "YYYYMMDD"
          ),
        },
      };

      //console.log('param', param)

      // @ts-expect-error
      const res = await clickPayCash(param);
      if (res.serviceCashUid !== "") {
        alert(t("cashStatus.requestNotic"));
        // window.location.href = `${process.env.PUBLIC_URL}/${lang}/bill`
        route.goBill();
      } else {
        alert(res.msg);
      }
    }
  };

  const showCashReqModal = () => {
    setShowCashRequestDel(true);
  };

  const hideCashReqModal = () => {
    setShowCashRequestDel(false);
  };

  const requestCancelCashStatus = async () => {
    // const checkCashStatus = await getCashUserStatus({
    //   product: [getProductFromSessionStorage()],
    // });
    // @ts-expect-error
    if (cashStatus) {
      //statusResult = checkCashStatus;
      const param: IUpdateCashStatus = {
        // @ts-expect-error
        serviceCashUid: cashStatus?.serviceCashUid,
        status: "CANCEL",
        msg: deleteCashReqMsg,
      };
      const res = await updateCashStatus({ ...param });
      if (res.serviceCashUid !== "") {
        alert(t("common.alert.cancelCard"));
        // setUserCashStatus(res);
        //isDone: false,
        setDeleteCashReqMsg("");
        setShowCashRequestDel(false);

        // window.location.href = `${process.env.PUBLIC_URL}/${lang}/bill`;
        route.goBill();
      } else {
        alert(res);
      }
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          licenseCount: 0,
          serviceBillUid: myServiceList[serviceNo]?.serviceBillUid,
        }}
        onSubmit={() => {}}
      >
        {(formikProps) => {
          return (
            <>
              {myServiceList && billHistory && (
                <BillUI
                  // {...formikProps}
                  changeNextPayDate={
                    myServiceList[serviceNo]?.nextPayDate?.toString() ?? ""
                  }
                  showCashReqModal={showCashRequestDel}
                  serviceList={myServiceList}
                  handleChange={handleChange}
                  modal={modal}
                  // 모달
                  toggleModalConfirmUser={toggleModalConfirmUser}
                  toggleModalSubscriptionsActivate={
                    toggleModalSubscriptionsActivate
                  }
                  toggleModalCheckConfirmPrice={toggleModalCheckConfirmPrice}
                  subscriptionsActivate={subscriptionsActivate}
                  // getBillHistory={getBillHistory}
                  currency={currency}
                  checkConfirmPrice={checkConfirmPrice}
                  inicisData={inicisData}
                  requestPay={requestPay}
                  // cashStatus={cashStatus}

                  showCashRequestDel={showCashRequestDel}
                  hideCashReqModal={hideCashReqModal}
                  deleteCashReqMsg={deleteCashReqMsg}
                  requestCancelCashStatus={requestCancelCashStatus}
                />
              )}
              <PriceChecker
                currency={currency}
                setPriceType={setPriceType}
                setUserPerPrice={setUserPerPrice}
                setUserPerPriceYear={setUserPerPriceYear}
                setPlanId={setPlanId}
                setPriceUid={setPriceUid}
              />
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default ConsoleBillContainer;
